<template>
    <div class="box">
      <img class="bj" src="@/assets/index_img/bj2.png" alt="">
      <div class="header">
        <p>勉县大数据服务中心</p>
      </div>
      <div class="back" @click="back">
        <img src="@/assets/index_img/back.png" alt="">
        <p>返回首页</p>
      </div>
      <div class="msg_tx" :id="msgShow==true?'msg_tx':''">
          暂未开放
        </div>
      <div class="content">
        <div class="content_box content_box1" @click="goPag(list[0].pth)">
          <div id="wrapper">
            <div class="main1 tool">
              <span></span>
              <span></span>
            </div>
            <div class="main2 tool">
              <span></span>
              <span></span>
            </div>
            <div class="main3 tool">
              <span></span>
              <span></span>
            </div>
          </div>
          <img v-if="list[0].img" :src="list[0].img" alt="">
          <p>{{list[0].title}}</p>
          <div class="content_nav">
            <div class="content_txt">
              <span v-for="item in 4"></span>
              <p>{{list[0].text}}</p>
            </div>
            <div class="content_msg">
              <h2>{{list[0].nav}}</h2>
            </div>
          </div>
        </div>
        <div class="content_box content_box2" @click="goPag(list[1].pth)">
          <div id="wrapper">
            <div class="main1 tool">
              <span></span>
              <span></span>
            </div>
            <div class="main2 tool">
              <span></span>
              <span></span>
            </div>
            <div class="main3 tool">
              <span></span>
              <span></span>
            </div>
          </div>
          <img v-if="list[1].img" :src="list[1].img" alt="">
          <p>{{list[1].title}}</p>
          <div class="content_nav">
            <div class="content_msg">
              <h2>{{list[1].nav}}</h2>
            </div>
            <div class="content_txt">
              <span v-for="item in 4"></span>
              <p>{{list[1].text}}</p>
            </div>
          </div>
        </div>
        <div class="content_box content_box3" @click="goPag(list[2].pth)">
          <div id="wrapper">
            <div class="main1 tool">
              <span></span>
              <span></span>
            </div>
            <div class="main2 tool">
              <span></span>
              <span></span>
            </div>
            <div class="main3 tool">
              <span></span>
              <span></span>
            </div>
          </div>
          <img v-if="list[2].img" :src="list[2].img" alt="">
          <p>{{list[2].title}}</p>
          <div class="content_nav">
            <div class="content_msg">
              <h2>{{list[2].nav}}</h2>
            </div>
            <div class="content_txt">
              <span v-for="item in 4"></span>
              <p>{{list[2].text}}</p>
            </div>
          </div>
        </div>
        <div class="content_box content_box4" @click="goPag(list[3].pth)">
          <div id="wrapper">
            <div class="main1 tool">
              <span></span>
              <span></span>
            </div>
            <div class="main2 tool">
              <span></span>
              <span></span>
            </div>
            <div class="main3 tool">
              <span></span>
              <span></span>
            </div>
          </div>
          <img v-if="list[3].img" :src="list[3].img" alt="">
          <p>{{list[3].title}}</p>
          <div class="content_nav">
            <div class="content_msg">
              <h2>{{list[3].nav}}</h2>
            </div>
            <div class="content_txt">
              <span v-for="item in 4"></span>
              <p>{{list[3].text}}</p>
            </div>
          </div>
        </div>
        <div class="content_box content_box5" @click="goPag(list[4].pth)">
          <div id="wrapper">
            <div class="main1 tool">
              <span></span>
              <span></span>
            </div>
            <div class="main2 tool">
              <span></span>
              <span></span>
            </div>
            <div class="main3 tool">
              <span></span>
              <span></span>
            </div>
          </div>
          <img v-if="list[4].img" :src="list[4].img" alt="">
          <p>{{list[4].title}}</p>
          <div class="content_nav">
            <div class="content_msg">
              <h2>{{list[4].nav}}</h2>
            </div>
            <div class="content_txt">
              <span v-for="item in 4"></span>
              <p>{{list[4].text}}</p>
            </div>
          </div>
        </div>
        <div class="content_box content_box6" @click="goPag(list[5].pth)">
          <div id="wrapper">
            <div class="main1 tool">
              <span></span>
              <span></span>
            </div>
            <div class="main2 tool">
              <span></span>
              <span></span>
            </div>
            <div class="main3 tool">
              <span></span>
              <span></span>
            </div>
          </div>
          <img  v-if="list[5].img" :src="list[5].img" alt="">
          <p>{{list[5].title}}</p>
          <div class="content_nav">
            <div class="content_msg">
              <h2>{{list[5].nav}}</h2>
            </div>
            <div class="content_txt">
              <span v-for="item in 4"></span>
              <p>{{list[5].text}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import Vue from 'vue'
// import { ACCESS_TOKEN } from "@/store/mutation-types"
import  menuList  from "../../assets/indexMenu"
import { setTimeout } from 'timers';
export default {
  name: 'Analysis2',
  components: {},
  data() {
    return {
      indexStyle: 0,
      nowTime: '',
      date: '',
      timer: '',
      list:[],
      msgShow:false,
      screenWidth: document.body.clientWidth
    }
  },
  created() {
    // this.nowTimes();
    let id = this.$route.query.id
    console.log("query",id);
    console.log("列表数据",menuList);
    this.list = menuList[--id]
    console.log("list",this.list);
    let that = this
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth
        that.screenWidth = window.screenWidth
      })()
    }
  },
  watch: {
    screenWidth(val) {
      // 为了避免频繁触发resize函数导致页面卡顿，使用定时器
      if (!this.timer) {
        // 一旦监听到的screenWidth值改变，就将其重新赋给data里的screenWidth
        this.screenWidth = val
        this.timer = true
        let that = this
        setTimeout(function() {
          // 打印screenWidth变化的值
          console.log('打印screenWidth变化的值', that.screenWidth)
          that.timer = false
        }, 400)
      }
    }
  },
  methods: {
    back(){
      this.$router.push("/dashboard/analysis")
    },
    goPag(pth){
      if(pth==""){
        this.msgShow = true
        setTimeout(()=>{
          this.msgShow = false
        },1500)
        return
      }
      let url =  pth;
      window.open(url, '_blank')
    }
  }
}
</script>

<style  lang="less" scoped>
.box::-webkit-scrollbar {
  display: none;
}
* {
  padding: 0px;
  margin: 0px;
}
p,h2,span{
    text-shadow: 0px 1px 2px rgba(0,0,0,0.89);
    letter-spacing: 1px;
  }
.box {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
  background: url(../../assets/index_img/bj.png) 60% no-repeat;
}
.bj {
  width: 100%;
  position: absolute;
  left: 50px;
  top: 0px;
}
.msg_tx{
  position: absolute;
  left: 50%;
  top: -60px;
  color: white;
  transition: all .4s linear;
  background: RGBA(20, 29, 39, .4);
  padding: 20px 40px;
  transform: translateX(-50%)
}
#msg_tx{
  top: 140px;
}
.header {
  width: 100%;
  height: 90px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: url(../../assets/index_img/nav.png) 60% no-repeat;
  p {
    text-shadow: 0px 0px 7px rgb(16 181 227);
    overflow-wrap: break-word;
    color: rgba(253, 253, 253, 1);
    font-size: 32px;
    letter-spacing: 4px;
    margin: 0px auto 10px;
  }
}
.back {
  position: absolute;
  left: 24px;
  top: 118px;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #b4c1c6;
  cursor: pointer;
  font-family: PingFangSC-Semibold, PingFang SC;
  text-shadow: 0px 1px 2px rgba(178, 241, 255, 0.76);
  img {
    width: 22px;
    height: 20px;
    margin-right: 6px;
  }
  p:hover {
    color: #45bee8;
  }
}
.content {
  width: 60%;
  height: 562px;
  position: absolute;
  left: 50%;
  transform: translateX(-45.7%);
  top: 270px;
  // border: 1px solid gray;
  .content_box:hover {
    > p {
      display: none;
    }
    > img {
      padding: 0px;
      transform: scale(1.2);
    }
    > .content_nav {
      opacity: 1;
    }
    #wrapper{
      display: block;
    }
    background: url(../../assets/index_img/bjk.png) !important;
  }
  .content_box {
    width: 215px;
    height: 187px;
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    cursor: pointer;
    background: url(../../assets/index_img/bjks.png) !important;
    // padding: 36px 0px;
    > img {
      display: block;
      transition: all 0.4s linear;
      padding: 31px 20px 0px;
    }
    > p {
      width: 100%;
      padding: 0px 20%;
      box-sizing: border-box;
      text-align: center;
      font-size: 18px;
      overflow-wrap: break-word;
      letter-spacing: 0.8px;
      margin-top: -40px;
      font-family: PingFangSC-Semibold,PingFang SC;
      color: rgba(255, 255, 255, 1);
    }
    .content_nav {
      opacity: 0;
      position: absolute;
      transition: all 0.8s linear;
      .content_txt {
        width: 405px;
        height: 96px;
        padding: 8px 10px 8px 20px;
        color: white;
        box-sizing: border-box;
        overflow: hidden;
        position: relative;
        p {
          width: 100%;
          height: 100%;
          overflow: hidden scroll;
        }
      }
      .content_txt p::-webkit-scrollbar {
        width: 2px;
        right: 20px;
      }
      .content_txt p::-webkit-scrollbar-thumb {
        width: 2px;
        background-color: rgba(39, 137, 216, 1);
      }
      .content_txt p::-webkit-scrollbar-track {
        width: 2px;
        background-color: rgba(216, 216, 216, 0.22);
      }
      .content_msg {
        height: 90px;
        background-size: 457px 91px;
        width: 452px;
        h2 {
          color: white;
          line-height: 80px;
          font-size: 30px;
          padding-left: 60px;
        }
      }
    }
  }
  .content_box1 {
    left: 50%;
    top: 0px;
    background: url(../../assets/index_img/bjk1.png);
    transform: translateX(-73%);
    .content_nav {
      left: 178px;
      top: -100px;
      .content_txt {
        background: url(../../assets/index_img/txt.png) -5px -3px no-repeat;
      }
      .content_msg {
        margin-top: 8px;
        background: url(../../assets/index_img/msg1.png) -5px -3px no-repeat;
      }
    }
  }
  .content_box2 {
    left: 52.1%;
    top: 104px;
    background: url(../../assets/index_img/bjk2.png);
    .content_nav {
      left: 178px;
      top: 0px;
      .content_txt {
        margin: 10px 0px 0px 46px;
        background: url(../../assets/index_img/txt.png) -5px -3px no-repeat;
      }
      .content_msg {
        background: url(../../assets/index_img/msg1.png) -5px -3px no-repeat;
      }
    }
  }
  .content_box3 {
    left: 52.1%;
    top: 316px;
    background: url(../../assets/index_img/bjk3.png);
    .content_nav {
      left: 178px;
      top: 0px;
      .content_txt {
        margin: 10px 0px 0px 46px;
        background: url(../../assets/index_img/txt.png) -5px -3px no-repeat;
      }
      .content_msg {
        background: url(../../assets/index_img/msg1.png) -5px -3px no-repeat;
      }
    }
  }
  .content_box4 {
    left: 50%;
    top: 420px;
    background: url(../../assets/index_img/bjk4.png);
    transform: translateX(-73%);
    .content_nav {
      left: 178px;
      top: 100px;
      .content_txt {
        margin: 10px 0px 0px 0px;
        background: url(../../assets/index_img/txt.png) -5px -3px no-repeat;
      }
      .content_msg {
        background: url(../../assets/index_img/msg2.png) -5px -3px no-repeat;
      }
    }
  }
  .content_box5 {
    left: 34.3%;
    top: 316px;
    background: url(../../assets/index_img/bjk5.png);
    transform: translateX(-73%);
    .content_nav {
      right: 184px;
      top: 0px;
      .content_txt {
        margin: 10px 0px 0px 0px;
        background: url(../../assets/index_img/txt.png) -5px -3px no-repeat;
      }
      .content_msg {
        background: url(../../assets/index_img/msg3.png) -5px -3px no-repeat;
      }
    }
  }
  .content_box6 {
    left: 34.3%;
    top: 104px;
    background: url(../../assets/index_img/bjk6.png);
    transform: translateX(-73%);
    .content_nav {
      right: 184px;
      top: 0px;
      .content_txt {
        margin: 10px 0px 0px 0px;
        background: url(../../assets/index_img/txt.png) -5px -3px no-repeat;
      }
      .content_msg {
        background: url(../../assets/index_img/msg3.png) -5px -3px no-repeat;
      }
    }
  }
}

// 流光特效
.content_txt span {
  position: absolute;
  display: block;
}
.content_txt span:nth-child(1) {
  top: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background: linear-gradient(90deg, transparent, #03f4d3);
  animation: animate1 1s linear infinite;
}
@keyframes animate1 {
  0% {
    left: -100%;
  }
  50%,
  100% {
    left: 100%;
  }
}
.content_txt span:nth-child(2) {
  top: -100%;
  right: 0;
  width: 2px;
  height: 100%;
  background: linear-gradient(180deg, transparent, #03f4d3);
  animation: animate2 1s linear infinite;
}
@keyframes animate2 {
  0% {
    top: -100%;
  }
  50%,
  100% {
    top: 100%;
  }
}
.content_txt span:nth-child(3) {
  bottom: 0;
  right: 0;
  width: 100%;
  height: 2px;
  background: linear-gradient(270deg, transparent, #03f4d3);
  animation: animate3 1s linear infinite;
}
@keyframes animate3 {
  0% {
    right: -100%;
  }
  50%,
  100% {
    right: 100%;
  }
}
.content_txt span:nth-child(4) {
  bottom: -100%;
  left: 0;
  width: 2px;
  height: 100%;
  background: linear-gradient(360deg, transparent, #03f4d3);
  animation: animate4 1s linear infinite;
}
@keyframes animate4 {
  0% {
    bottom: -100%;
  }
  50%,
  100% {
    bottom: 100%;
  }
}
.content_txt span:nth-child(1) {
  animation-delay: 0s;
}
.content_txt span:nth-child(2) {
  animation-delay: 0.25s;
}
.content_txt span:nth-child(3) {
  animation-delay: 0.5s;
}
.content_txt span:nth-child(4) {
  animation-delay: 0.75s;
}
// 六边形流光特效
  #wrapper {
			width: 200px;
			height: 200px;
			margin-left: 40px;
      position: absolute;
      left: 14px;
      top: 0px;
      display: none;  
		}
		#wrapper p{
			position: absolute;
			left: 50%;
			top: 50%;
			color: white;
			width: 100%;
			margin: 0px;
			transform: translate(-50%,-50%);
			z-index: 2;
		}
		.main1 {
		    width: calc(190px / 1.732);
		    height: 186px;
		}
		.main2 {
		    width: calc(190px / 1.732);
		    height: 186px;
		    transform: rotate(120deg);
		}
		.main3 {
		    width: calc(190px / 1.732);
		    height: 186px;
		    transform: rotate(240deg);
		}
		.tool{
		    position: absolute;
		    top: 0;
		    left: 0;
			overflow: hidden;
		}
		.main1 :nth-child(1),.main2 :nth-child(1),.main3 :nth-child(1){
			position: absolute;
			width: 100%;
			height: 2px;
			top: 0px;
			opacity: 0;
			background: linear-gradient(90deg,transparent,#03f4d3);
			animation: animate11 1.2s linear infinite;
		}
		@keyframes animate11{
		    0%{
		        left: -150%;
				opacity: 1;
		    }
		    50%,100%{
		        left: 100% ;
				opacity: 1;
		    }
		}
		.main1 :nth-child(2),.main2 :nth-child(2),.main3 :nth-child(2){
			position: absolute;
			width: 100%;
			height: 2px;
			right: 0px;
			bottom: 0px;
			opacity: 0;
			background: linear-gradient(-135deg,transparent,#03e9f4);
			animation: animate22 1.2s linear infinite;
		}
		@keyframes animate22{
		    0%{
		        left: 150%;
				opacity: 1;
		    }
		    50%,100%{
		        left: -100%;
				opacity: 1;
		    }
		}
		.main1 span:nth-child(1){
		    animation-delay: 0s;
		}
		.main1 span:nth-child(2){
		    animation-delay: 0.6s;
		}
		.main2 span:nth-child(1){
		    animation-delay: 0.4s;
		}
		.main2 span:nth-child(2){
		    animation-delay: 1s;
		}
		.main3 span:nth-child(1){
		    animation-delay: 0.8s;
		}
		.main3 span:nth-child(2){
		    animation-delay: 0.2s;
		}
</style>